import React from 'react';
import { Icon } from 'react-fa';
import Row from './Row';

export default class TableComponent extends React.Component {
  handleClick = i => {
    const colNumber = i + 1;
    this.props.handleClick(colNumber);
  };
  render() {
    return (
      <table className="table is-hoverable is-fullwidth is-bordered">
        <thead>
          <tr>
            {this.props.headerTitles.map((name, i) => (
              <th key={i} onClick={this.handleClick.bind(this, i)}>
                <span>{name}</span>
                <span className="icon has-text-brand is-small">
                  {this.props.sortOrder === `col${i + 1}Ascending` && (
                    <Icon name="angle-up" />
                  )}
                  {this.props.sortOrder === `col${i + 1}Descending` && (
                    <Icon name="angle-down" />
                  )}
                </span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {this.props.tableData.map((row, i) => <Row key={i} {...row} />)}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SortableTable/TableComponent.js